module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "multiselect"
  }, _vm._l((_vm.options), function(option) {
    return _c('li', [_c('button', {
      class: _vm.getOptionClasses(option),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleOption(option)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getOptionLabel(option)) + "\n        ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-355d701e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/multiselect/index.vue
// module id = 2013
// module chunks = 2